import { render, staticRenderFns } from "./GuestBoxExt.vue?vue&type=template&id=1e63cd4b&scoped=true&"
import script from "./GuestBoxExt.vue?vue&type=script&lang=js&"
export * from "./GuestBoxExt.vue?vue&type=script&lang=js&"
import style0 from "./GuestBoxExt.vue?vue&type=style&index=0&id=1e63cd4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e63cd4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e63cd4b')) {
      api.createRecord('1e63cd4b', component.options)
    } else {
      api.reload('1e63cd4b', component.options)
    }
    module.hot.accept("./GuestBoxExt.vue?vue&type=template&id=1e63cd4b&scoped=true&", function () {
      api.rerender('1e63cd4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bDCRZHq716kA/JS/comp/GuestBoxExt.vue"
export default component.exports